import type { VFC } from 'react'
import { useEffect, useRef } from 'react'
import { Button } from '@opallabs/lapidary'
import * as styles from './styles'
import type { LegalTakeoverProps } from './types'

export const LegalTakeover: VFC<LegalTakeoverProps> = ({
  content,
  onAccept,
  theme = 'light',
  title,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  // auto-focus takeover on render
  // @note `deps` array is intentionally empty so this only runs once
  useEffect(() => {
    ref.current?.focus()
  }, [])

  /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
  return (
    <div css={styles.shroud}>
      <div
        css={styles.container({ theme })}
        ref={ref}
        role="alert"
        tabIndex={-1}
      >
        <div css={styles.sizedColumn}>
          <h1 css={styles.heading({ theme })}>{title}</h1>

          <div
            css={styles.content({ theme })}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
            tabIndex={0}
          />

          <footer css={styles.footer({ theme })}>
            <Button
              buttonText="Accept"
              variant="primary"
              name="takeover_accept"
              onClick={onAccept}
              theme={theme}
            />
          </footer>
        </div>
      </div>
    </div>
  )
  /* eslint-enable jsx-a11y/no-noninteractive-tabindex */
}
LegalTakeover.displayName = 'BlackHole: LegalTakeover'
